import { useEffect, useState } from "react";
import MarketingLayout from "@/components/layout/MarketingLayout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { MapPin, Briefcase } from "lucide-react";

export default function Careers() {
  const [roles, setRoles] = useState([]);
  useEffect(() => { api.get("/cms/careers").then((r) => setRoles(r.data)).catch(() => {}); }, []);

  return (
    <MarketingLayout>
      <section className="page-shell px-6 py-20">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Careers</div>
          <h1 className="font-display text-5xl lg:text-6xl mt-3">Build the future of lending, with us.</h1>
          <p className="text-lg text-muted-foreground mt-6">We hire kind, thoughtful people who care about craft. Come make something beautiful and useful.</p>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5">
          {roles.map((r) => (
            <Card key={r.id} className="p-6 card-hover flex items-center justify-between gap-4">
              <div>
                <div className="font-display text-xl">{r.title}</div>
                <div className="flex gap-4 mt-2 text-sm text-muted-foreground">
                  <span className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{r.location}</span>
                  <span className="inline-flex items-center gap-1"><Briefcase className="h-3.5 w-3.5" />{r.type}</span>
                </div>
              </div>
              <Button variant="outline" className="rounded-full" data-testid={`career-apply-${r.id}`}>Apply</Button>
            </Card>
          ))}
        </div>
      </section>
    </MarketingLayout>
  );
}
